/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthAdminLoginInput } from "../../entities/models/AuthAdminLoginInput";
import { z } from "zod/v4";

export const modelsAuthAdminLoginInputSchema = z.object({
    "email": z.string(),
"password": z.string()
    }) as unknown as z.ZodType<ModelsAuthAdminLoginInput>